import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate from 'vuex-persistedstate'
import cst from './const'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    [cst.AREA]: {
      provinceId: '',
      province: '全国',
      cityId: '',
      city: '全国'
    },
    [cst.AUTO_AREA]: {
      provinceId: '',
      province: '全国',
      cityId: '',
      city: '全国',
      latitude: '',
      longitude: ''
    },
    [cst.DEPART]: {},
    headerHeight: 0,
    measureDeviceData: {},
    baseOrderInfo: []
  },
  getters: {},
  mutations: {
    [cst.AREA]: (state, value) => {
      state[cst.AREA] = value
    },
    [cst.AUTO_AREA]: (state, value) => {
      state[cst.AUTO_AREA] = value
    },
    [cst.DEPART]: (state, value) => {
      state[cst.DEPART] = value
    },
    setHeaderHeight (state, height) {
      state.headerHeight = height
    },
    setMeasureDeviceData (state, value) {
      state.measureDeviceData = value
    }
  },
  plugins: [
    createPersistedstate({
      key: 'vuexData'
    })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js